// extracted by mini-css-extract-plugin
export default {"header1":"styles_header1__2oHsY","block1":"styles_block1__rcTcz","tableContainer":"styles_tableContainer__zGCjT"};